import { ReactNode, useRef } from "react";
import { useBoundingclientrect } from "rooks";
import { POINTS_LARGE_ICON_WIDTH, POINTS_SMALL_ICON_WIDTH } from "./constants";
import { clampPoints } from "@silo/utils";

const marginAdjustment =
  (POINTS_LARGE_ICON_WIDTH - POINTS_SMALL_ICON_WIDTH) / 2;

interface PositionedPointsProps {
  points: number[];
  indicators: ReactNode[];
}

export function PositionedPoints({
  points,
  indicators,
}: PositionedPointsProps): JSX.Element {
  const normalizedPoints = points.map(clampPoints);
  const firstPoint = useRef<HTMLDivElement | null>(null);
  const rect = useBoundingclientrect(firstPoint);

  return (
    <div
      style={{
        marginLeft: marginAdjustment,
        marginRight: marginAdjustment,
      }}
    >
      <div className="relative flex" style={{ height: rect?.height || "32px" }}>
        {normalizedPoints.map((value, index) => {
          return (
            <span
              key={index}
              className="absolute inline-block"
              ref={index === 0 ? firstPoint : undefined}
              style={{
                left: `${value}%`,
                transform: `translateX(-50%)`,
              }}
            >
              {indicators[index] ?? null}
            </span>
          );
        })}
      </div>
    </div>
  );
}
